import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './container/api.js'
import apiDoc from './container/apiDoc.js'
import liff from '@line/liff'
import liffDoc from './container/liffDoc'
import toolDoc from './container/toolDoc'
import tool from './components/utils/tool'
import PortalVue from 'portal-vue'

Vue.use(PortalVue)

Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$apiDoc = apiDoc
Vue.prototype.$liff = liff
Vue.prototype.$liffDoc = liffDoc
Vue.prototype.$toolDoc = toolDoc
Vue.prototype.$tool = tool
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
